import { getOr } from '@/utils/options';
import { Paragraph } from 'components/src/typography';
import * as React from 'react';
import { LargeAddOnFieldsFragment } from 'types/generated';
import Images from './Images';
import AddToPackageCard from './AddToPackageCard';
import { appendAddOnsAtom } from '@/store';
import { useSetAtom } from 'jotai';
import { AddOn } from '@/models/PackageTypes';

type Props = {
  data: LargeAddOnFieldsFragment;
};

const LargeAddOn = ({ data }: Props) => {
  const appendAddOns = useSetAtom(appendAddOnsAtom);

  React.useEffect(() => {
    const addOnToAdd: AddOn = {
      id: data?.id,
      title: data.title,
      price: data.price,
      multiselect: false,
    };

    if (addOnToAdd) {
      appendAddOns([addOnToAdd]);
    }
  }, [appendAddOns, data]);
  return (
    <div className="mt-64">
      <Paragraph classes="mb-32 text-black-100">{getOr(data.description, '')}</Paragraph>
      {data.imagesCollection?.items && <Images images={data.imagesCollection.items} />}
      <AddToPackageCard data={data} />
    </div>
  );
};

export default LargeAddOn;
